import * as React from "react"
const Beef = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#FFD0CD"
      d="m24.667 8 2.92 6c.276.862.416 1.762.413 2.667a8.654 8.654 0 0 1-3.467 6.933c-4 3.333-9.866 5.733-15.2 5.733A4 4 0 0 1 5.76 27.12L3.2 22"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m24.667 8 2.92 6c.276.862.416 1.762.413 2.667a8.654 8.654 0 0 1-3.467 6.933c-4 3.333-9.866 5.733-15.2 5.733A4 4 0 0 1 5.76 27.12L3.2 22"
    />
    <path
      fill="#FF9A94"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.667 2.667A8.667 8.667 0 0 0 8.373 8.8c-1.466 4.173-1.04 5.2-4.24 8.107A4 4 0 0 0 6.667 24c5.333 0 11.2-2.4 15.2-5.733a8.667 8.667 0 0 0-5.2-15.6Z"
    />
    <path
      fill="#DB6E67"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.667 14.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Z"
    />
  </svg>
)
export default Beef
